import Modifier from 'ember-modifier';

interface OnValuesChangeSignature {
  Args: {
    Positional: [handler: () => void, ...watched: unknown[]];
  };
}

export default class OnValuesChangeModifier extends Modifier<OnValuesChangeSignature> {
  private hasRun = false;

  modify(
    _element: Element,
    [handler]: OnValuesChangeSignature['Args']['Positional'],
  ): void {
    if (!this.hasRun) {
      this.hasRun = true;
      return;
    }

    handler();
  }
}
